import { createColumnHelper } from '@tanstack/react-table';

import { VulnerabilityRow } from '../types';

export const columnHelper = createColumnHelper<VulnerabilityRow>();
